module.exports = __webpack_public_path__ + "static/logo_mds_title-632d6d55748cd6068d85247578b9e62c.svg";